import { connect } from 'react-redux'

const mapStateToProps = () => ({})
const actions = {}

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
